import React from 'react';
import { Navigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress, Typography, Button } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, subscription } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '100vh',
          background: '#0a1628',
          gap: 2
        }}
      >
        <CircularProgress sx={{ color: '#ff6b35' }} />
        <Typography sx={{ color: '#8892a4' }}>Yükleniyor...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Allow access to payment page even if subscription expired
  if (location.pathname === '/payment') {
    return children;
  }

  // Check subscription status
  if (subscription && !subscription.active) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '100vh',
          background: '#0a1628',
          textAlign: 'center',
          p: 3
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', mb: 2 }}>
          ⏰ Deneme Süreniz Sona Erdi
        </Typography>
        <Typography sx={{ color: '#8892a4', mb: 3, maxWidth: 500 }}>
          7 günlük ücretsiz deneme süreniz doldu. NBA Analytics'i kullanmaya devam etmek için 
          premium üyeliğe geçin.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            component={Link}
            to="/payment"
            sx={{
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              color: '#000',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)',
              }
            }}
          >
            ⭐ Premium'a Geç - $20/ay
          </Button>
        </Box>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;








